// ratingIcons.js
import React from 'react';
import { Box } from '@mui/material';

const ThumbsUpSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
                                <path d="M7.30144 10.85V25.25M16.9837 5.906L15.7734 10.85H22.8294C23.2052 10.85 23.5758 10.9367 23.9119 11.1034C24.248 11.27 24.5404 11.5119 24.7659 11.81C24.9914 12.1081 25.1437 12.4541 25.211 12.8207C25.2782 13.1873 25.2584 13.5643 25.1532 13.922L22.3332 23.522C22.1866 24.0205 21.8808 24.4584 21.4618 24.77C21.0428 25.0816 20.5332 25.25 20.0095 25.25H3.67057C3.0286 25.25 2.41292 24.9971 1.95897 24.5471C1.50502 24.097 1.25 23.4865 1.25 22.85V13.25C1.25 12.6135 1.50502 12.003 1.95897 11.5529C2.41292 11.1029 3.0286 10.85 3.67057 10.85H7.01097C7.4613 10.8498 7.90263 10.725 8.28535 10.4897C8.66806 10.2544 8.97699 9.91786 9.17738 9.518L13.3529 1.25C13.9236 1.25701 14.4854 1.3918 14.9962 1.64432C15.507 1.89683 15.9537 2.26053 16.3028 2.70824C16.652 3.15596 16.8946 3.67611 17.0125 4.22984C17.1304 4.78357 17.1206 5.35656 16.9837 5.906Z"
                                    fill="#FFBF00"
                                    stroke="#3A3A3A"
                                    stroke-width="2.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
);

const ThumbsDownSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
                            <path d="M7.30144 15.65V1.25M16.9837 20.594L15.7734 15.65H22.8294C23.2052 15.65 23.5758 15.5633 23.9119 15.3966C24.248 15.23 24.5404 14.9881 24.7659 14.69C24.9914 14.3919 25.1437 14.0459 25.211 13.6793C25.2782 13.3127 25.2584 12.9357 25.1532 12.578L22.3332 2.978C22.1866 2.47948 21.8808 2.04157 21.4618 1.73C21.0428 1.41843 20.5332 1.25 20.0095 1.25H3.67057C3.0286 1.25 2.41292 1.50286 1.95897 1.95294C1.50502 2.40303 1.25 3.01348 1.25 3.65V13.25C1.25 13.8865 1.50502 14.497 1.95897 14.9471C2.41292 15.3971 3.0286 15.65 3.67057 15.65H7.01097C7.4613 15.6502 7.90263 15.775 8.28535 16.0103C8.66806 16.2456 8.97699 16.5821 9.17738 16.982L13.3529 25.25C13.9236 25.243 14.4854 25.1082 14.9962 24.8557C15.507 24.6032 15.9537 24.2395 16.3028 23.7918C16.652 23.344 16.8946 22.8239 17.0125 22.2702C17.1304 21.7164 17.1206 21.1434 16.9837 20.594Z"
                                fill="#FAA0A0"
                                stroke="#880808"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
);

export const RATING_ICONS = {
    two_thumbs_up: (
        <Box display="flex" alignItems="center" gap={0.5}>
            <ThumbsUpSvg />
            <ThumbsUpSvg />
        </Box>
    ),
    thumbs_up: <ThumbsUpSvg />,
    thumbs_down: <ThumbsDownSvg />,
};